import {useContext} from 'react';
import {E4ImpactProjectsContext} from './E4ImpactProjectsProvider';

export function useE4ImpactProjectsContext() {
    const context = useContext(E4ImpactProjectsContext);

    if (!context) throw new Error('useE4ImpactProjectsContext must be use inside E4ImpactProjectsProvider');

    return context;
}
